import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-machine-properties',
  templateUrl: './machine-properties.component.html',
  styleUrls: ['./machine-properties.component.scss']
})
export class MachinePropertiesComponent implements OnInit {

  @Input() machine !: any;

  public left !: boolean;

  constructor() { }

  ngOnInit(): void {
    this.getDirection();
  }

  public getDirection(){
    if(this.machine.cote_portes=='Droite'){
      this.left = false;
    }else{
      this.left = true;
    }
  }

}
